import {TooltipContainerDefaultBox} from "./tooltip-container.default";

export const TooltipContainerBox = TooltipContainerDefaultBox;